import type { CartItem } from '../types';

const sapHybrisMergeToCard = async (newItems: CartItem[]) => {
  for (const productCode of newItems) {
    // @ts-ignore
    window.addToCartNewHybris(productCode.productId);
  }
};
export default sapHybrisMergeToCard;
